import axios from '@/api/axios';
import type {
  BusinessLiveAccessListResponse,
  BusinessLiveAccessStatus,
  BusinessLiveAccessTemplate,
  BusinessLiveAccessTemplateView,
  BusinessLiveAccessView,
  UpdateLiveAccessPayload,
  UpsertLiveAccessTemplatePayload,
} from '@/types';

const BASE_URL = '/v2/admin/business/live-access';

export const liveAccessService = {
  getList: async (
    filters: {
      status?: BusinessLiveAccessStatus;
      search?: string;
      page?: number;
      limit?: number;
    } = {},
  ): Promise<BusinessLiveAccessListResponse> => {
    const query: Record<string, string> = {
      page: String(filters.page ?? 0),
      limit: String(filters.limit ?? 10),
    };
    if (filters.status) {
      query.status = filters.status;
    }
    if (filters.search) {
      query.search = filters.search;
    }
    const url = `${BASE_URL}?${new URLSearchParams(query).toString()}`;
    const response = await axios.get<BusinessLiveAccessListResponse>(url);
    return response?.data;
  },

  getById: async (requestId: string): Promise<BusinessLiveAccessView> => {
    const response = await axios.get<BusinessLiveAccessView>(
      `${BASE_URL}/${requestId}`,
    );
    return response?.data;
  },

  update: async (
    requestId: string,
    payload: UpdateLiveAccessPayload,
  ): Promise<BusinessLiveAccessView> => {
    const response = await axios.patch<BusinessLiveAccessView>(
      `${BASE_URL}/${requestId}`,
      payload,
    );
    return response?.data;
  },

  getTemplates: async (): Promise<BusinessLiveAccessTemplateView[]> => {
    const response = await axios.get<BusinessLiveAccessTemplateView[]>(
      `${BASE_URL}/templates`,
    );
    return response?.data ?? [];
  },

  // The server's PUT .../templates handler (adminUpsertLiveAccessTemplate)
  // sends `response ?? null`, so a not-found/failed upsert reaches this
  // client as a JSON `null`, never as a missing body, hence `| null` here
  // rather than `| undefined`.
  upsertTemplate: async (
    payload: UpsertLiveAccessTemplatePayload,
  ): Promise<BusinessLiveAccessTemplate | null> => {
    const response = await axios.put<BusinessLiveAccessTemplate | null>(
      `${BASE_URL}/templates`,
      payload,
    );
    return response?.data;
  },
};
